import React from 'react';
import { connect } from 'react-redux';
import { onReplaceLinkClick } from 'ctm-util-functions';
import styles from './click_to_edit_car_details.css';

/**
 * Render the Click To Edit Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const _ClickToEditCarDetails = (props) => {
    const { hasBeenPrefilled, clearForm } = props;
    const handleOnReplaceLinkClick = (event) =>  onReplaceLinkClick(event, hasBeenPrefilled ? '/car-insurance/journey/start' : '/car-insurance/journey/edit_car_details');

    return (
        <div className={styles.root}>
            <span className={styles.text}> {hasBeenPrefilled ? "Looking for a different car?" : "If this doesn't look right,"}  </span>
            <a
                data-id="edit_car_details_link"
                href="#"
                className={styles.detailsLink}
                onClick={ (event) => {
                    if (hasBeenPrefilled) {
                        clearForm();
                    }
                    handleOnReplaceLinkClick(event);
                }}>
                    {hasBeenPrefilled ? " Start a new quote" : " click here"}
            </a>
        </div>
    );
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    const hasBeenPrefilled =   state.getIn(['page', 'hasBeenPrefilled']);
    return { hasBeenPrefilled };
};

const mapDispatchToProps = (dispatch) => ({
    // Manually clear all journey data
    clearForm: () => {
        dispatch({
            type: 'RESET_VALUES',
            stateKey: 'vertical.quote',
            identifiers: [
                'applicant',
                'helpers.overnightParkingAddressLabel',
                'coverDetail',
                'coverDetails',
                'anyPreviousClaimsCount',
                'apiResponses'
            ]
        });
        dispatch({
            type: 'SET_VALUE',
            stateKey: 'vertical.quote',
            identifier: 'helpers.regoLabel',
            value: null
        });
        dispatch({
            type: 'RESET_TOUCHES',
            stateKey: 'vertical.quote',
            identifiers: [
                'coverDetail.driver.dob',
                'helpers.regoLabel',
                'firstPage.vehicle.rego'
            ]
        });
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'hasBeenPrefilled',
            value: false
        });
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'prefillJourney',
            value: false
        });
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'hasSeenResults',
            value: false
        });
        dispatch({
            type: 'SET_VALUE',
            stateKey: 'vertical.quote',
            identifier: 'helpers.prefill.isEditingDetails',
            value: false
        });
    }
});

const ClickToEditCarDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ClickToEditCarDetails);

export { ClickToEditCarDetails, _ClickToEditCarDetails, mapDispatchToProps };